// FAH (Forced-Air Heater) sections — Main Burner / Pilot / Ignitor.
//
// "FAH" is the config with NO main burner: BURNER_QTY = MAIN_BURNER_0, whose own
// answer label is literally "0 - FAH". All three sections carry the native
// NetSuite group hide rule "BURNER_QTY/MAIN_BURNER_0", so on an FAH they hide
// themselves — and their mapped item fields transfer as null through the encoder
// (the runtime's mapping-mode hide path nulls each field's slot; dropdowns resolve
// to their "None" list option, the two computed fields clear).
//
// HISTORY: cpq2 briefly REVEALED these three sections (collapsed + optional) for an
// FAH via a shadow answer state that deleted the "no main burner" token. Per a later
// request that reveal was removed — an FAH now simply hides them (below,
// fahSectionHideState is a pass-through). The identity set + isFah are kept because
// the group codes still identify these sections for any FAH-specific handling.

// FAH is a Natural Draft BURNER configuration, so the group codes that identify
// these sections come from the running configurator's profile (src/products/) rather
// than a module constant. A product with no FAH concept declares an empty set, and
// isFahSectionGroupCode is false for everything there -- it does not merely happen to
// miss because its group codes are spelled differently.
import type { AnswerState } from "../types";
import { getProfile } from "../products";

// BURNER_QTY = "0 - FAH". Selecting this is what makes a config an FAH.
const BURNER_QTY_ZERO_KEY = "BURNER_QTY/MAIN_BURNER_0";

/** An FAH config = the "0 - FAH" main-burner count is selected. */
export function isFah(answers: AnswerState): boolean {
  return answers[BURNER_QTY_ZERO_KEY] === true;
}

/** True for a configurator's FAH sections (Main Burner / Pilot / Ignitor in NDB). */
export function isFahSectionGroupCode(product: string, code: string): boolean {
  return getProfile(product).fahSectionGroupCodes.has(code);
}

/** Answer state to evaluate a section's hide rules with. Pass-through: it returns
 *  the ORIGINAL state unchanged for every group, including the FAH sections — so
 *  on an FAH the native "BURNER_QTY/MAIN_BURNER_0" group rule fires and Main Burner
 *  / Pilot / Ignitor HIDE. (Formerly this returned a shadow with the "no main
 *  burner" token removed to REVEAL them; that reveal has been retired.) Kept as a
 *  stable seam for the call sites in TabPanel / Group / validation. */
export function fahSectionHideState(
  _groupCode: string,
  answers: AnswerState
): AnswerState {
  return answers;
}
